import api from './api'

export const storesService = {
  async getAllStores() {
    return await api.get('/stores')
  },

  async getStoreById(id) {
    return await api.get(`/stores/${id}`)
  },

  async getStoreProducts(storeId) {
    return await api.get(`/stores/${storeId}/products`)
  },

  async importData(formData) {
    return await api.post('/stores/import-data', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  },

  async importAmazonData(formData) {
    return await api.post('/stores/import-amazon-data', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  }
} 
